export default "__VITE_ASSET__DU_Gbdul__"